import React, { useEffect, useState } from 'react';
import { get } from 'lodash';
import { GlobalNavigationLineOfBusiness } from 'src/common/__generated__/api/types';
import { css } from 'styled-components';
import { Layout } from 'src/components/common/modules/layout/layout';

// UITK components
import { DatePicker, Typeahead } from 'src/components/common/modules/form';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { PrimaryButton, PrimaryButtonProps } from 'src/components/common/ui/button/button';
import { UitkLayoutFlex } from 'uitk-react-layout-flex';

//helpers
import {
  formatDateWithLang,
  getDateFormatWithLang,
  getLocalizationData,
  getWizardUrlOverrideURL,
  getWizOverrideDateParaName,
  renderInvalidTypeheadStyles,
  getWizardDefaults,
  WizardDefaultProps,
  wizardDate,
  getWizardsOverrides,
  getValidReturnDate,
} from '../../../helpers';
import { checkValue, cookieHelper, LightenDarkenColor } from 'src/components/common/helper';
import { UitkButtonSize } from 'uitk-react-button';
import { getSearchToolsQueryParams, QueryParamsStrategies } from '@shared-utils/search-tools-query-params-mapper';
import { linkTabOpenner } from '../../../SearchWizard';
import { useLocalization } from '@shared-ui/localization-context';
import { useStores } from 'src/utils/useStore';
import { Traveller } from 'src/components/common/modules/form/traveller/traveller';
import { Typo } from 'src/components/common/ui';
import { sendSearchWizardSearchGTMEvent } from 'src/components/common/utils/gtmHelperFunctions';

const HotelsHotelWidget: React.FC<any> = ({ wizardLocalization, data, mccidData }) => {   
  const { context } = useStores();   
  const siteBrand = context?.site?.brand;
  const device = context?.deviceInformation?.type ||  'DESKTOP';
  
  const urlParam = {
    adults: '1',
    children: '0',
    childrenAges: '',
    endDate: '',
    origin: '',
    startDate: '',
    petIncluded: 'false',
  };

  const Wlocalization = {
    adult: "adult",
    adults: "adults",
    button_txt: "Apply",
    child: "child",
    child_age: "Child #number age",
    children: "children",
    error_msg: "Please fix the errors first",
    guest: "Travelers",
    guests: "Travelers",
    how_old_child: "How old is the child?",
    how_old_childern: "How old are the children?",
    no: "No",
    pets: "Pets",
    price_info_msg: "This helps us show you a more accurate price",
    property_msg: "Only properties that allow pets will be shown",
    travelers: "Select guests",
    yes: "Yes"
  }
  const { formatDateString } = useLocalization();

  const today = new Date();
  const dayAfterTwoWeeks = new Date();
  const nextDayAfterDayAfterTwoWeeks = new Date();
  dayAfterTwoWeeks.setDate(today.getDate() + 14);
  nextDayAfterDayAfterTwoWeeks.setDate(today.getDate() + 15);

  const searchedDateFormat = getDateFormatWithLang(context?.locale, 'yyyy-MM-dd');

  // Check the default data is coming from the searchOverride if so
  // Get the code
  const wizardDefault: WizardDefaultProps = {
    data,
    lob: 'Hotel',
    overrideController: 'returnDefault',
  };
  const wizardReturnDefaultPreset: WizardDefaultProps = {
    data,
    lob: 'Hotel',
    overrideController: 'returnPreset',
  };
  const wizardOverrideDefault = getWizardDefaults(wizardDefault);
  const wizardHotelDestinationPresetDefault = getWizardDefaults(wizardReturnDefaultPreset);
  let returnDefault = '';
  let isWizardOverrideUrlIgnore = true;

  /**
   * 1) if wizard override in hotel tab - check returnDefault is available
   * 2) else if wizard override in hotel tab - check returnDefaultPreset is available
   * 3) else common returnDefault
   */
  if (checkValue(wizardOverrideDefault, true)) {
    const getReturn = wizardOverrideDefault?.find((w) => w.key === 'returnDefault');
    if (checkValue(getReturn) && checkValue(getReturn.value)) {
      returnDefault = getReturn?.value;
      isWizardOverrideUrlIgnore = false;
    }
  } else if (checkValue(wizardHotelDestinationPresetDefault, true)) {
    const getReturn = wizardHotelDestinationPresetDefault?.find((w) => w.key === 'returnPreset');
    if (checkValue(getReturn) && checkValue(getReturn.value)) {
      returnDefault = getReturn?.value;
    }
  } else {
    returnDefault = get(data, 'returnDefault', '');
  }

  // Get Wizard Overrides Date
  const wizardOverrides = getWizardsOverrides(data, 'Hotel');
  let wizardOverridesDepartureDate = '';
  let wizardOverridesReturnDate = '';
  if (checkValue(wizardOverrides, true)) {
    wizardOverridesDepartureDate = wizardOverrides?.[0]?.dateFrom;
    wizardOverridesReturnDate = wizardOverrides?.[0]?.dateTo;
  }

  const departureDate = wizardDate(
    get(data, 'departureDate', ''),
    get(data, 'departureDateFixed', ''),
    wizardOverridesDepartureDate,
    dayAfterTwoWeeks,
    get(data, 'daysInFuture', ''),
    ''
  );
  const returnDatewizardDate = wizardDate(
    get(data, 'returnDate', ''),
    get(data, 'returnDateFixed', ''),
    wizardOverridesReturnDate,
    nextDayAfterDayAfterTwoWeeks,
    get(data, 'daysInFuture', ''),
    get(data, 'lengthOfStay', '')
  );
  const returnDate = getValidReturnDate(departureDate, returnDatewizardDate);

  const initFormState = {
    goingTo: { value: returnDefault, error: '', typeHeadId: 'textDestiWizard' },
    departureDate: {
      value: departureDate,
      error: '',
    },
    returnDate: {
      value: returnDate,
      error: '',
    },
  };

  const [formState, setFormState] = useState(initFormState);

  //onChangeHandler
  const onChangeHandler = (state, value) => {
    setFormState((prev) => ({
      ...prev,
      [state]: {
        ...prev?.[state],
        value,
        error: '',
      },
    }));
  };

  //handle validations
  const handleValidations = () => {
    let isValidate = true;
    let goingToError = '';
    let departureDateError = '';
    let returnDateError = '';

    if (formState?.goingTo?.value === '') {
      isValidate = false;
      goingToError = getLocalizationData(wizardLocalization?.hotels, 'select_destination', 'Please select a destination', device);
    }

    if (formState?.departureDate?.value === '') {
      isValidate = false;
      departureDateError = 'Departure Date Error';
    }

    if (formState?.returnDate?.value === '') {
      isValidate = false;
      returnDateError = 'Return Date Error';
    }

    setFormState((prev) => ({
      ...prev,
      goingTo: { ...prev?.goingTo, error: goingToError },
      returnDate: { ...prev?.returnDate, error: returnDateError },
      departureDate: { ...prev?.departureDate, error: departureDateError },
    }));

    return isValidate;
  };

  const handleSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (handleValidations()) {
      const { elements } = event.currentTarget;
      const tempobj = { ...urlParam };
      const inputs = Array.from(elements) as HTMLInputElement[];

      const queryParams = getSearchToolsQueryParams(QueryParamsStrategies.LODGING, inputs);

      let searchURL = '';
      let domain = window?.location?.origin;
      const urlParams = new URLSearchParams(window?.location?.search);
      const lagnParam = checkValue(urlParams) ? urlParams?.get('lang') : '';
      let preferlocale = '';
      if(checkValue(lagnParam)){
        domain = domain+'/'+lagnParam?.toLowerCase()?.replace('_','-');
        preferlocale = '&preferlocale=true'
      }

      inputs.forEach((input) => {
        const inputVal: string = checkValue(input.value) ? input.value : '';

        if (input.name !== '') {
          if (input.name === 'EGDSSearchFormTravelersField-Adult-Room1') {
            tempobj.adults = inputVal;
          }
          if (input.name === 'EGDSSearchFormLocationField-Location-destination_form_field') {
            tempobj.origin = inputVal;
          }
          if (input.name === 'EGDSDateRangePicker-StartDate-date_form_field') {
            tempobj.startDate = inputVal.split(' - ')[0];
            tempobj.endDate = inputVal.split(' - ')[1];
          }
          if (input.name === 'traveler-adults') {
            tempobj.adults = inputVal;
          }
          if (input.name === 'traveler-children' && inputVal !== '') {
            tempobj.childrenAges = inputVal;
            tempobj.children = inputVal?.split(',')?.length?.toString();
          }
          if (input.name === 'traveler-petInclude') {
            tempobj.petIncluded = inputVal;
          }
          return { ...tempobj };
        }
      });

      const startDateFormatHotels = formatDateWithLang(context?.locale, tempobj.startDate, 'yyyy-MM-dd');
      const endDateFormatHotels = formatDateWithLang(context?.locale, tempobj.endDate, 'yyyy-MM-dd');

      if (siteBrand === 'hotels') {       
        searchURL =
          getWizardUrlOverrideURL('Hotel', domain + '/Hotel-Search', data?.wizardUrlOverride) +
          'destination=' +
          tempobj.origin +
          '&' +
          getWizOverrideDateParaName('Hotel', 'dateFrom', 'DATEFROM', 'd1', data?.wizardUrlOverride) +
          '=' +
          formatDateString(startDateFormatHotels?.date, { raw: 'yyyy-MM-dd' }) +
          '&' +
          getWizOverrideDateParaName('Hotel', 'dateTo', 'DATETO', 'd2', data?.wizardUrlOverride) +
          '=' +
          formatDateString(endDateFormatHotels?.date, { raw: 'yyyy-MM-dd' }) +
          '&' +
          getWizOverrideDateParaName('Hotel', 'dateFrom', 'DATEFROM', 'startDate', data?.wizardUrlOverride) +
          '=' +
          formatDateString(startDateFormatHotels?.date, { raw: 'yyyy-MM-dd' }) +
          '&' +
          getWizOverrideDateParaName('Hotel', 'dateTo', 'DATETO', 'endDate', data?.wizardUrlOverride) +
          '=' +
          formatDateString(endDateFormatHotels?.date, { raw: 'yyyy-MM-dd' }) +
          '&adults=' +
          tempobj.adults+
          '&rooms=1';
         
          if (tempobj?.children && tempobj?.children !== '0' && tempobj?.childrenAges) {
            const childSearch = tempobj?.childrenAges
              .split(',')
              .map((age) => `1_${age}`)
              .join(',');
          
            searchURL += (searchURL.includes('?') ? '&' : '?') + `children=${childSearch}`;
          }


      } else if (siteBrand === 'vrbo') {
        // Vrbo child cookie for search
        if (checkValue(tempobj?.childrenAges)) {
          const haChildCookie = cookieHelper.getCookie('ha-children-age-prst');
          if (checkValue(haChildCookie)) {
            cookieHelper.deleteCookie('ha-children-age-prst');
          }
          cookieHelper.setCookie(
            'ha-children-age-prst',
            JSON.stringify({ childrenAges: tempobj?.childrenAges?.split(',') }),
            1
          );
        } else {
          cookieHelper.deleteCookie('ha-children-age-prst');
        }

        let searchDataForVrbo = '';
        if (checkValue(tempobj)) {
          if (tempobj?.origin) {
            searchDataForVrbo += `keywords:${tempobj?.origin}/`;
          }
          if (tempobj?.startDate) {
            searchDataForVrbo += `arrival:${tempobj?.startDate}/`;
          }
          if (tempobj?.endDate) {
            searchDataForVrbo += `departure:${tempobj?.endDate}/`;
          }
          if (tempobj?.adults) {
            searchDataForVrbo += (searchDataForVrbo.indexOf('?') > -1 ? '&' : '?') + `adultsCount=${tempobj?.adults}`;
          }
          if (tempobj?.children && tempobj?.children !== '0') {
            searchDataForVrbo +=
              (searchDataForVrbo.indexOf('?') > -1 ? '&' : '?') + `childrenCount=${tempobj?.children}`;
          }
          if (tempobj?.petIncluded) {
            searchDataForVrbo +=
              (searchDataForVrbo.indexOf('?') > -1 ? '&' : '?') + `petIncluded=${tempobj?.petIncluded}`;
          }
        }

        const vrboMainUrl =
          getWizardUrlOverrideURL('Hotel', domain + '/search/', data?.wizardUrlOverride)
            .replace('?', '')
            .replace('&', '') + searchDataForVrbo;
       
        searchURL = vrboMainUrl+preferlocale;       
      } else {
        if (checkValue(data?.wizardUrlOverride, true) && !isWizardOverrideUrlIgnore) {
          const objURL = data?.wizardUrlOverride.filter((item) => item.wizardTab === 'Hotel');
          if (checkValue(objURL?.[0])) {
            const tempURL = 'go/hotel/search/Destination';
            const hotelOverrideURL = getWizardUrlOverrideURL('Hotel', '/Hotel-Search?', data?.wizardUrlOverride);
            const newHotelOverrideURL =
              tempURL +
              '/' +
              formatDateString(startDateFormatHotels?.date, { raw: 'yyyy-MM-dd' }) +
              '/' +
              formatDateString(endDateFormatHotels?.date, { raw: 'yyyy-MM-dd' });

            searchURL = hotelOverrideURL.replace(tempURL, newHotelOverrideURL) + '&adults=' + tempobj.adults;
          } else {
            searchURL = `/Hotel-Search${queryParams}`;
          }
        } else {
          searchURL = `/Hotel-Search${queryParams}`;
        }
      }

      const searchParameters = startDateFormatHotels?.date + ' - ' + endDateFormatHotels?.date + '|' + tempobj.origin;

      sendSearchWizardSearchGTMEvent('wizard_search', 'Hotels', searchParameters , searchURL);
          
      linkTabOpenner(searchURL, mccidData);
    }
  };

  const updateTypeahead = (selectedValue) => {
    onChangeHandler('goingTo', selectedValue);
  };
  const updateDates = (startDate, endDate) => {
    console.log(startDate, endDate);
  };

  const primaryButtonProps: PrimaryButtonProps = {
    text: getLocalizationData(wizardLocalization?.hotels, 'search_button_copy', 'Search', device),
    tag: 'button',
    gaTracking: {
      eventCategory: 'Button Click',
      eventAction: 'Featured Content',
      eventLabel: `${getLocalizationData(wizardLocalization?.hotels, 'search_button_copy', 'Search', device)} - ${'cTALink'}`,
    },
    exClass: `btn mobile-btn`,
    target: '_blank',
    size: UitkButtonSize.LARGE,
    iconPos: 'BEFORE_TEXT',
  };
  useEffect(() => {
    const errors = Object.keys(formState)
      .map((key) => ({
        error: get(formState, `[${key}].error`, ''),
        typeheadId: get(formState, `[${key}].typeHeadId`, ''),
      }))
      .filter(({ typeheadId }) => typeheadId !== '' && typeheadId !== false && typeheadId !== undefined);

    renderInvalidTypeheadStyles(errors);
  }, [formState]);

  const btnyDarkColor = LightenDarkenColor(get(data, 'cTAColor', ''), -0.1);

  const moduleCss = () => {

    return `
        ${ 
          checkValue(data.cTAColor) ?
          `
              .uitk-button-primary{              
                background-color:${get(data, 'cTAColor', '')} !important;
                border-color: ${get(data, 'cTAColor', '')} !important;
                &:hover{
                  background-color: ${btnyDarkColor} !important;
                  border-color: ${btnyDarkColor} !important;
                }
              }
          ` : ''}
          ${ 
            checkValue(data.cTATextColor) ?
            `
                .uitk-button-primary{              
                  color: ${get(data, 'cTATextColor', '')} !important;
                }
            ` : ''}  
          `;
  };

  return (
    <>
      <Layout
          className="hotels-booking-section"
          css={css`
            ${moduleCss()}
          `}
          id={'lodging-search-form'}
        >
      {/* <div className="hotels-booking-section" data-testid="lodging-search-form"> */}
        <div className="hotels-booking-form-wrapper">
          <form onSubmit={handleSubmit} className="hotels-booking-form">
            {checkValue(data?.title) && (
              
                <div className="hotels-heading-wrapper">
                  <Typo.HTMLText tag="h2" exClass="hotels-heading-text override-heading-font-family">
                    {data?.title}
                  </Typo.HTMLText>
                </div>
              
            )}
            <UitkLayoutFlex space="six" alignItems="center" justifyContent="end"></UitkLayoutFlex>
            <div className="grid">
              <UitkLayoutGrid columns={{ small: 1 }} space="three" className="wizard-row-top-margin">
                <UitkLayoutGridItem>
                  {/* <UitkLayoutGrid columns={{ small: 1, medium: 4 }} space="three">  */}
                  <UitkLayoutGrid space="three" className='wizard-controllers-container'>
                    <UitkLayoutGridItem>
                      <div className="hotels-search-destination">
                        <Typeahead
                          controlid={formState?.goingTo?.typeHeadId}
                          label={getLocalizationData(
                            wizardLocalization?.hotels,
                            'location_label_copy',
                            'Where do you want to go?',
                            device
                          )}
                          icon={'place'}
                          name={'EGDSSearchFormLocationField-Location-destination_form_field'}
                          controller={'typeahead'}
                          updateModel={updateTypeahead}
                          placeholder={getLocalizationData(
                            wizardLocalization?.hotels,
                            'location_label_copy',
                            'Where do you want to go?',
                            device
                          )}
                          value={formState?.goingTo?.value}
                          hasClearButton={false}
                          lob={GlobalNavigationLineOfBusiness.HOTEL}
                          error={''}
                          device={device}
                          isHeroWizard={true}
                        />
                      </div>
                    </UitkLayoutGridItem>
                    <UitkLayoutGridItem>
                      <div className="hotels-search-dates">
                        <DatePicker
                          updateDates={updateDates}
                          startDate={formState?.departureDate?.value}
                          endDate={formState?.returnDate?.value}
                          startPlaceHolder={getLocalizationData(
                            wizardLocalization?.hotels,
                            'check_in_label_copy',
                            'Check-in',
                            device
                          )}
                          endPlaceHolder={getLocalizationData(
                            wizardLocalization?.hotels,
                            'check_out_label_copy',
                            'Check-out',
                            device
                          )}
                          startDateState={'packageStartDate'}
                          endDateState={'packageEndDate'}
                          singleMode={false}
                          doubleMonths={true}
                          selectCopy={getLocalizationData(
                            wizardLocalization?.hotels,
                            'date_picker_select',
                            'Select Date',
                            device
                          )}
                          // for now hear start time label hard coded until updated the wizard localization
                          // startLabel={getLocalizationData(wizardLocalization?.hotels, 'check_in_label_copy', 'Dates', device)} 
                          startLabel={'Dates'}
                          endLabel={getLocalizationData(wizardLocalization?.hotels, 'check_out_label_copy', 'Check-out', device)}
                          singleDateSelect={true}
                          useSingleTrigger={true}
                          dateFormat={searchedDateFormat}
                          startInvalid={formState?.departureDate?.error}
                          endInvalid={formState?.returnDate?.error}
                        />
                      </div>
                    </UitkLayoutGridItem>
                    <UitkLayoutGridItem>
                      <UitkLayoutGridItem>
                        <div className="hotels-search-guests">
                          <Traveller {...Wlocalization} petControlEnable = {false}/>
                        </div>
                      </UitkLayoutGridItem>
                    </UitkLayoutGridItem>
                    <UitkLayoutGridItem>
                        <UitkLayoutGridItem>
                          <div className="wizard-search-button-container">
                            <PrimaryButton {...primaryButtonProps} />
                          </div>
                        </UitkLayoutGridItem>
                    </UitkLayoutGridItem>
                  </UitkLayoutGrid>
                </UitkLayoutGridItem>
              </UitkLayoutGrid>
            </div>
          </form>
        </div>
      {/* </div> */}
      </Layout>
    </>
  );
};

export default HotelsHotelWidget;